/* @flow */

import AccurateTimestamp from '../dateTime/AccurateTimestamp';
import { MILLISECONDS_PER_SECOND } from '../dateTime/Format';

export type CACHE_TYPE = {
  [string]: {
    input: any,
    output: any,
  },
};

type HasDate = { +date: string };

const getHashFromDate: (items: ReadonlyArray<HasDate>) => string | null = (items) => {
  if (!items) {
    return null;
  }

  return items.map((item) => item.date).join();
};

const getCacheExpirationTime: (maxAge: ?number) => number = (maxAge) => {
  const now = AccurateTimestamp.now();
  return maxAge ? now + maxAge * MILLISECONDS_PER_SECOND : now;
};

export { getCacheExpirationTime, getHashFromDate };
